<template>
    <v-btn text small class="base-button-next" v-bind="$attrs" v-on="$listeners">
        <span class="mr-2"><slot></slot></span>
        <img :src="svgSource" alt="next-button" onload="SVGInject(this)" style="transform: rotate(900deg)"/>
    </v-btn>
</template>

<script>
export default {
    props: {
        svgSource: { type: String, default: '/images/_SVGs/back.svg' }
    }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';
.base-button-next {
    ::v-deep rect {
        transition: ease $animations-time-duration;
        fill: var(--v-primary-base);
    }
    &:hover {
        ::v-deep rect {
            transition: ease $animations-time-duration;
            fill: var(--v-primary-lighten2);
        }
        span {
            color: var(--v-primary-lighten2);
        }
    }
    &:disabled {
        opacity: 0.6;
        filter: grayscale(100%);
    }
    span {
        text-transform: capitalize;
        font-size: 15px;
        color: var(--v-primary-base);
        transition: ease $animations-time-duration;
    }
}
</style>
